module.exports = __webpack_public_path__ + "img/itx-text-bold.3a9e47bf.svg";